import styled from 'styled-components'

export const Container = styled.div`
  /* 73px because is the height of the header + 8px distance to the bottom of the screen */
  max-height: calc(100vh - 73px - 8px);
  overflow-y: auto;
`
